import Vue from 'vue'
import router from './router'
import store from './store'
// import { Notification } from 'element-ui'
import { getQueryVariable } from '@/utils/commom.js'
import setting from '@/config/setting'

router.beforeEach(async (to, from, next) => {
  // store.commit(
  //   'commom/setToken',
  //   '17b64b4848b464c0d13361326731ae3939cef4d027ee897da51ae9fab0a975f7'
  // )
  // 当前未保存token
  if (!store.state.commom.token) {
    if (getQueryVariable('token')) {
      store.commit('commom/setToken', getQueryVariable('token'))
      next()
    } else {
      window.location.href = setting.callbackUrl
      next()
    }
  } else {
    next()
  }
})
